import { LinearTransform, transformCSS } from '@st/geom'
import { Fragment, ReactNode, forwardRef } from 'react'
import { ResolvedPageStructure } from './models'
import { useLinearTransform } from './use-linear-transform'
import { PAGE_VERTICAL_SPACING_PX } from './viewer-geometry'
import { usePageShouldRender } from './document-viewport'

type Props = {
  page: ResolvedPageStructure
  pageToolbar?: ReactNode
  topDivider?: ReactNode
  bottomDivider?: ReactNode
  children: ReactNode
}

export const Page = forwardRef<HTMLDivElement, Props>(function Page(
  { page, pageToolbar, topDivider, bottomDivider, children },
  ref
) {
  const transform = useLinearTransform()
  const shouldRender = usePageShouldRender(page.pageNumber)
  const transformedBounds = LinearTransform.apply(page.bounds, transform)
  const transformedVerticalPageSpacing = LinearTransform.apply(
    { x: 0, y: PAGE_VERTICAL_SPACING_PX },
    transform
  )

  const dividerStyle = {
    height: transformedVerticalPageSpacing.y,
    width: transformedBounds.width
  }

  return (
    <Fragment>
      {topDivider !== undefined && (
        <div className="mx-auto" style={dividerStyle}>
          {topDivider}
        </div>
      )}

      <div
        ref={ref}
        className="DocumentPageViewer drawing-canvas group relative mx-auto box-border border"
        style={{ width: transformedBounds.width, height: transformedBounds.height }}
      >
        {pageToolbar !== undefined && shouldRender && (
          <div className="absolute -top-5 h-5 w-full px-2">{pageToolbar}</div>
        )}

        {page.isDeleted == true ? (
          <div
            className="bg-white"
            style={{
              width: page.bounds.width,
              height: page.bounds.height,
              ...transformCSS(transform)
            }}
          >
            <span className="flex h-full items-center justify-center text-xs text-gray-500">
              Deleted Page
            </span>
          </div>
        ) : (
          <div
            className="relative"
            style={{
              width: page.bounds.width,
              height: page.bounds.height,
              ...transformCSS(transform)
            }}
          >
            {shouldRender ? children : null}
          </div>
        )}
      </div>

      {bottomDivider !== undefined && (
        <div className="mx-auto" style={dividerStyle}>
          {bottomDivider}
        </div>
      )}
    </Fragment>
  )
})
